<button [attr.id]="id" class="dashboard-action-btn btn-block" type="button" (click)="onClick()">
    <h6 class="action-item">{{ actionItem }}</h6>
    <div class="action-element">
        <span class="action-counter">{{ counter }}</span>
        <img [src]="iconSrc" alt="" />
    </div>
</button>